var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSubscriptionNextBillingDate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#DDECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 11V15M17 11V15M12 19H30M14 13H28C29.1046 13 30 13.8954 30 15V29C30 30.1046 29.1046 31 28 31H14C12.8954 31 12 30.1046 12 29V15C12 13.8954 12.8954 13 14 13Z",
    stroke: "#6B7DE5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSubscriptionNextBillingDate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_subscription_next_billing_date.63c79f328a7599c113f6f0c42ce0f976.svg";